<mat-toolbar color="accent">Generate OHSA Enrolment Form</mat-toolbar>

<div class="flex flex-col gap-3 overflow-hidden bg-gray-50 p-4">
  <pr-information-box>
    Review and fill any missing information to be sent to MOH. You will be able
    to view, edit and manually sign the filled PDF form after this step.
  </pr-information-box>

  <form class="grid grid-cols-2 gap-3" [formGroup]="form">
    <div
      class="border-1 col-span-1 flex flex-col gap-3 rounded-md border border-solid border-gray-300 bg-white p-3"
    >
      <div class="mb-3 font-bold">Agreement Holder Information</div>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Agreement Holder Name</mat-label>
        <input matInput formControlName="agreementHoldersName" />
      </mat-form-field>

      <div class="flex w-full gap-2">
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Practice Payee Number</mat-label>
          <input matInput formControlName="payeeNumber" />
        </mat-form-field>
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Practice Agreement Number</mat-label>
          <input matInput formControlName="agreementNumber" />
        </mat-form-field>
      </div>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Practice District</mat-label>
        <mat-select formControlName="districtArea">
          @for (district of districts; track district) {
            <mat-option [value]="district">{{ district }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Practice Physical Address</mat-label>
        <textarea matInput formControlName="practicePhysicalAddress"></textarea>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Practice Postal Address</mat-label>
        <textarea matInput formControlName="practicePostalAddress"></textarea>
      </mat-form-field>

      <div class="flex-1"></div>
    </div>

    <div
      class="col-span-1 flex flex-col gap-3 rounded-md border border-solid border-gray-300 bg-white p-4"
    >
      <div class="font-bold">Patient Information</div>

      <div class="flex w-full gap-2">
        <mat-checkbox class="flex-1" formControlName="newEnrolment">
          New Enrolment
        </mat-checkbox>
        <mat-checkbox class="flex-1" formControlName="changeOfDentalProvider">
          Change of Dental Provider
        </mat-checkbox>
      </div>

      <div class="flex w-full items-start gap-2">
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Patient Name</mat-label>
          <input matInput formControlName="patientName" />
        </mat-form-field>
        <pt-iso-date-selector
          class="flex-1"
          placeholder="Patient Date of Birth"
          formControlName="patientDateOfBirth"
          [max]="today"
        />
      </div>

      <div class="flex w-full gap-2">
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Patient NHI Number</mat-label>
          <input matInput formControlName="nhiNumber" />
        </mat-form-field>
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Name of Signatory (Patient or Guardian)</mat-label>
          <input matInput formControlName="patientOrGuardianName" />
        </mat-form-field>
      </div>

      <div class="flex w-full gap-2">
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Patient Mobile</mat-label>
          <input matInput formControlName="patientMobile" />
        </mat-form-field>
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Patient Day Phone Number</mat-label>
          <input
            maxlength="9"
            matInput
            formControlName="patientDayPhoneNumber"
          />
        </mat-form-field>
      </div>

      <div class="flex w-full gap-2">
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Patient School Year</mat-label>
          <input
            matInput
            type="number"
            max="13"
            formControlName="patientSchoolYear"
          />
        </mat-form-field>
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Patient Postcode</mat-label>
          <input matInput type="number" formControlName="patientPostcode" />
        </mat-form-field>
      </div>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Patient Residential Address</mat-label>
        <textarea matInput formControlName="patientAddress"></textarea>
      </mat-form-field>
    </div>
  </form>

  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Close</button>
    <pt-loader-button
      type="flat"
      color="primary"
      [loading]="loading()"
      [disabled]="loading()"
      (clicked)="submit()"
    >
      Generate Form
    </pt-loader-button>
  </pt-buttons-container>

  @if (showRequiredError()) {
    <span class="text-warn-500 self-end text-xs">
      Please complete all required fields
    </span>
  }
</div>
